import type { StoreState } from '@sparky/framework'
import { useEffect, useMemo, useState } from 'react'
import { Body, CardHeader, Card, CardBody } from '@panwds/react-ui'
import AppBanner from '../../../subscription/components/EnterpriseActivation/components/Licenses/AppBanner'

interface DefaultPlatformProps {
  state: StoreState,
  title: string,
  connectedPlatforms: Map<string, object>,
  infoMessage: string,
  defaultPlatformId: string,
}

const PlatformBanner = ({ state, ...props }: DefaultPlatformProps) => {
  const { instances, tsg, loadingTsg } = state
  const { title, connectedPlatforms, infoMessage, defaultPlatformId } = props
  const [loading, setLoading] = useState<boolean>(false)
  useEffect(() => {
    setLoading(loadingTsg && tsg)
  }, [instances, loadingTsg, tsg])

  const LineItem = (props: any) => {
    const { platform, tenantStatus, message } = props
    return (
      <div className='tw-flex tw-space-x-10 tw-py-1 tw-pl-2 tw-pb-0 tw-text-xs'>
        <div className="tw-flex-none tw-basis-28">{platform}</div>
        <div className="tw-flex-none tw-basis-40">{tenantStatus}</div>
        <div className="tw-flex-grow">{message || ''}</div>
      </div>
    )
  }

  const platforms = useMemo(() => {
    const canBeUsedInstances = instances?.filter((instance: any) => connectedPlatforms.has(instance.app_id))?.map((instance: any) => {
      return { ...connectedPlatforms.get(instance.app_id) }
    })
    canBeUsedInstances.push({ ...connectedPlatforms.get(defaultPlatformId) })
    return canBeUsedInstances.map((each: any, index: any) => {
      return <LineItem key={index} {...{ ...each }} />
    })
  }, [connectedPlatforms, defaultPlatformId, instances])

  const bannerDetails = { 'info': infoMessage, className: 'tw-p-6 tw-space-y-1 tw-text-xs' }
  return (
    <div className="tw-w-auto">
      <Card style={{ borderRadius: 0 }} addClassName='tw-flex tw-flex-row'>
        <CardHeader title={title} />
        <CardBody isLoading={loading} addClassName='tw-pb-0'>
          <Body> {platforms}</Body>
        </CardBody>
        <AppBanner {...bannerDetails}></AppBanner>
      </Card>
    </div >
  )
}

export default PlatformBanner
